export default {
  QUIZ: "quiz",
  ADD_FILE: "addFile",
  TASK: "task",
  SELECT_ANSWER: "selectAnswer",
};
